// extracted by mini-css-extract-plugin
module.exports = {"statuses":"style_statuses__1Md-V"};